//React
import * as React from 'react';
import { useState } from 'react';
//Material UI
import { Button, Box, Typography, TextField, Container } from "@mui/material";
//Routing
import { useNavigate } from "react-router-dom";
//Components
import theme from "../../Global/theme";
import { useGetUserDetailsQuery } from '../api/apiSlice';
export default function PageProfile() {
  
  const [name, setName] = useState("");
  const [surname, setSurname] = useState("");
  const [cell_number, setCell_number] = useState("");

  const [email, setemail] = useState("");

  const {
    data: userData,
    isLoading: userLoading,
    isSuccess: userSuccess,
    isError: userError,
    error: userMessage,
  } = useGetUserDetailsQuery();

  let navigate = useNavigate();

  const handleSubmit = (event) => {};

  const handleBack = (event) => {
    event.preventDefault();
    navigate(-1);
  };

  // `auth/user_details/` with no user_id returns the signed-in user as { data: {...} }. This
  // read `user_details`, `cell_number` and `groups`, none of which that endpoint has ever sent.
  const details = userData?.data;

  React.useEffect(() => {
    if (userSuccess) {
      setCell_number(details.number)
      setName(details.first_name)
      setSurname(details.last_name)
      setemail(details.email)
  
      };
    
  }, [userSuccess, userLoading, userError]);

  if (userLoading) {
    return <></>;
  } else if (userError) {
    return <></>;
  } else {  

    return (
      <Container component="main" maxWidth="xs" sx={{ mb: 5 }}>
        <Box sx={{ "& button": { m: 2 } }}>
          <Typography
          
            gutterBottom
            variant="h3"
            component="h3"
            value
          >
            Profile Details
          </Typography>
          <Box component="form" onSubmit={handleSubmit}>
            <Typography
            
              gutterBottom
              variant="h5"
              component="h5"
            >
              Personal Details
            </Typography>
            <TextField
              onChange={(e) => setName(e.target.value)}
              //key={props.profilePersonal.id_number}
              //defaultValue={id_number}
              margin="normal"
              className="inputRounded"
              required
              fullWidth
              id="name"
              label="Name"
              name="name"
              autoComplete="name"
              value={name || ""}
              // error= {!(/^\d{13}$/.test(id_number))}
              // helperText={!(/^\d{13}$/.test(id_number)) ? "ID number must be 13 numerical digits" : ""}
            />

            <TextField
              onChange={(e) => setSurname(e.target.value)}
              //key={props.profilePersonal.id_number}
              //defaultValue={id_number}
              margin="normal"
              className="inputRounded"
              required
              fullWidth
              id="surname"
              label="Surname"
              name="surname"
              autoComplete="surname"
              value={surname || ""}
              // error= {!(/^\d{13}$/.test(id_number))}
              // helperText={!(/^\d{13}$/.test(id_number)) ? "ID number must be 13 numerical digits" : ""}
            />

            <TextField
              onChange={(e) => setemail(e.target.value)}
              //key = {props.profilePersonal.email}
              //defaultValue={props.profilePersonal.email}
              margin="normal"
              className="inputRounded"
              required
              fullWidth
              name="email"
              label="Email"
              id="email"
              autoComplete="email"
              value={email || ""}
            />

            <TextField
              onChange={(e) =>
                setCell_number(e.target.value)
              }
              //key = {props.profilePersonal.email}
              //defaultValue={props.profilePersonal.email}
              margin="normal"
              className="inputRounded"
              required
              fullWidth
              name="cell_number"
              label="Cell Number"
              id="cell_number"
              autoComplete="cell_number"
              value={cell_number || ""}
            />



            {(details?.user_groups ?? []).map((temp) => (
              <TextField
                key={temp.unique_name}
                margin="normal"
                className="inputRounded"
                required
                fullWidth
                name="groups"
                label="Allocated Group"
                id="groups"
                autoComplete="groups"
                value={temp.unique_name || ""}
              />
            ))}

            <Container xs={6} align="middle">
            {/* <Button
                sx={theme.mainButton.root}
                onClick={handleUpdate}
                align="middle"
              >
                Update
              </Button> */}
              <Button
                sx={theme.mainButton.root}
                onClick={handleBack}
                align="middle"
              >
                Back
              </Button>
            </Container>
          </Box>
        </Box>
      </Container>
    );
  }
}
